import { render, staticRenderFns } from "./BlockType2.vue?vue&type=template&id=14d8d023"
import script from "./BlockType2.vue?vue&type=script&lang=ts"
export * from "./BlockType2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports